import classNames from 'classnames'
import { isRedesignEnabled } from 'finviz-charts/app/utils'
import React from 'react'

import { ChartTypesSelect, StockDetailTimeframeBar } from '../../../../app/charts-lib'
import { Button } from '../../../components'
import { SpecificChartFunctionality } from '../../../constants/common'
import { QuoteContext } from '../QuoteContext'

interface Props {
  isStockDetailUpdating: boolean
}

const hasRedesign = isRedesignEnabled()
const isPremium = window.FinvizSettings.hasUserPremium

export function StaticChartHeader({ isStockDetailUpdating }: Props) {
  const { index, ticker, period } = React.useContext(QuoteContext)

  return (
    <div
      className={classNames('mb-1 flex items-center p-1.5 py-0.5 font-sans', {
        'border-b border-[#f3f3f3]': !hasRedesign,
      })}
    >
      <div className="w-full" />
      <div className="ml-auto mr-0.5 items-center">
        <ChartTypesSelect
          rounding={hasRedesign ? 'regular' : 'none'}
          size="medium"
          isPremium={isPremium}
          specificFunctionality={SpecificChartFunctionality.quotePage}
        />
      </div>
      <div className="ml-0.5 w-[26.75rem] shrink-0 overflow-hidden">
        <StockDetailTimeframeBar
          size="medium"
          chartIndex={index}
          isPremium={FinvizSettings.hasUserPremium}
          isDateRangeAvailable={false}
          isLoadingOverride={isStockDetailUpdating}
          isScrollIntoViewEnabled
        />
      </div>
      <div className="flex w-full justify-end">
        <Button
          rounding={hasRedesign ? undefined : 'none'}
          leftContent="share"
          size="medium"
          className="js-publish-chart"
          data-testid="chart-toolbar-publish"
          data-index={index}
          data-ticker={ticker}
          data-timeframe={period}
        >
          Share
        </Button>
      </div>
    </div>
  )
}
